module.exports = __webpack_public_path__ + "static/media/qr-myvnpt-android.4fb8bcf1.png";